import { Typography } from '@mui/material'

const DeltaPill = ({ delta }: { delta: string }) => {
  const isPositive = delta.startsWith('+')

  return (
    <Typography
      sx={{
        fontSize: '8px',
        fontWeight: 600,
        lineHeight: '11px',
        padding: '1px 5px',
        borderRadius: '7px',
        whiteSpace: 'nowrap',
        backgroundColor: isPositive ? '#E5F5E7' : '#FDEDED',
        color: isPositive ? '#6B9070' : '#C62828',
      }}
    >
      {delta}
    </Typography>
  )
}

export default DeltaPill
